import React from "react";
import { NavLink } from "react-router-dom";

export default function NavBar(){

    return(
        <div className="Navbar">
         <NavLink className="navlink" to="/home/aircrafts">View Flights</NavLink>
         <NavLink className="navlink" to="/home/about">About</NavLink>
         <NavLink className="navlink" to="/home/book">Book Flights</NavLink>  
         <NavLink className="navlink" to="/home/reviews">Reviews</NavLink> 
        </div>
    )
}